import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const createReqArriveLateSlice = createSlice({
  name: "createReqArriveLate",
  initialState,
  reducers: {
    createReqArriveLateStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    createReqArriveLateSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    createReqArriveLateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  createReqArriveLateStart,
  createReqArriveLateSuccess,
  createReqArriveLateFailed,
} = createReqArriveLateSlice.actions;

export default createReqArriveLateSlice.reducer;
